"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

var AccordionArrow = function AccordionArrow(props) {
  return (
    /*#__PURE__*/
    _react["default"].createElement("svg", _extends({
      width: "15",
      height: "15",
      viewBox: "0 0 15 15"
    }, props),
    /*#__PURE__*/
    _react["default"].createElement("title", null, "Down arrow"),
    /*#__PURE__*/
    _react["default"].createElement("path", {
      strokeWidth: "2",
      d: "M3 5l4.5 5L12 5",
      fill: "none"
    }))
  );
};

var _default = AccordionArrow;
exports["default"] = _default;